import { useQuery } from "@tanstack/react-query";
import { fetchOrganizations } from "@/lib/api";
import { useDashboardOrg } from "@/app/DashboardOrgContext";
import { SearchableSelect } from "@/components/ui/searchable-select";
import { useT } from "@/app/localization";

/**
 * Org switcher for a MULTI-ORG manager — chooses which managed organization the
 * dashboard (units / stats / sessions) is scoped to. Hidden for a system admin
 * (fleet view) and for a manager of a single org (auto-selected). Driver-only
 * orgs never appear — manageableOrgIds is the manager set.
 */
export function DashboardOrgSelector() {
  const t = useT();
  const { dashboardOrgId, manageableOrgIds, isMultiOrg, setDashboardOrgId } = useDashboardOrg();
  const q = useQuery({ queryKey: ["organizations"], queryFn: fetchOrganizations, enabled: isMultiOrg });

  if (!isMultiOrg) return null;
  const manageable = new Set(manageableOrgIds);
  const orgs = (q.data?.organizations ?? []).filter((o) => manageable.has(o.id));

  return (
    <div data-testid="dashboard-org-selector" className="mr-3">
      <SearchableSelect
        className="w-40 sm:w-56"
        options={orgs.map((o) => ({ value: String(o.id), label: o.name }))}
        value={dashboardOrgId != null ? String(dashboardOrgId) : null}
        onValueChange={(v) => setDashboardOrgId(Number(v))}
        placeholder={t("operator.org_selector.placeholder")}
        searchPlaceholder={t("operator.org_selector.search_placeholder")}
        emptyText={t("operator.org_selector.no_match")}
      />
    </div>
  );
}
